module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_SpatialResearch.41604f0b.png";